export default __webpack_public_path__ + "static/media/register.a939002e.riv";